import { ActionReducerMap, createFeatureSelector } from '@ngrx/store';
import * as fromAddress from './address/address.reducer';
import * as fromAnnualReward from './annual-reward/annual-reward.reducer';
import * as fromCalculation from './calculation/calculation.reducer';
import * as fromCountry from './country/country.reducer';
import * as fromInvoices from './invoices/invoices.reducer';
import * as fromProductPanel from './product-panel/product-panel.reducer';
import * as fromProduct from './product/product.reducer';
import * as fromScenarios from './scenarios/scenarios.reducer';

export interface State {
    myZone: MyZoneState;
}

export interface MyZoneState {
    product: fromProduct.State;
    invoices: fromInvoices.State;
    calculation: fromCalculation.State;
    scenarios: fromScenarios.State;
    address: fromAddress.State;
    country: fromCountry.State;
    annualReward: fromAnnualReward.State;
    productPanel: fromProductPanel.State;
}

export const reducers: ActionReducerMap<MyZoneState> = {
    product: fromProduct.reducer,
    invoices: fromInvoices.reducer,
    calculation: fromCalculation.reducer,
    scenarios: fromScenarios.reducer,
    address: fromAddress.reducer,
    country: fromCountry.reducer,
    annualReward: fromAnnualReward.reducer,
    productPanel: fromProductPanel.reducer,
};

export const getMyZoneState = createFeatureSelector< MyZoneState>('myZone');
